import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { SeoService } from '../../_services/seo/seo.service';
import { ActualiteService } from '../../_services/actualite/actualite.service';
import { Actualite } from '../../_interfaces/actualite';
import { ActualiteCardComponent } from '../../_components/actualite-card/actualite-card.component'

@Component({
    selector: 'app-actualites',
    imports: [ActualiteCardComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './actualites.component.html'
})
export class ActualitesComponent {
  actualiteService = inject(ActualiteService);
  actualites: Actualite[] = [];

  private seo = inject(SeoService);

  constructor() {
    this.seo.set({
      title: 'Actualités',
      description: 'Les actualités de La Bourrée de Paris : spectacles, voyages, vie du groupe folklorique auvergnat de Paris.',
      path: '/actualites',
    });
    this.readActualites();
  }

  readActualites() {
    this.actualiteService.readPublishedActualites().subscribe(
      actualites => this.actualites = actualites,
      error => console.error('Erreur lors de la récupération des actualités:', error)
    );
  }
}
